$(document).ready(function(){

  var controller = new ScrollMagic.Controller();

  $(function () {
    //var tween = TweenMax.to(".block-list", 1, {className: "+=scrollend"});


      if(window.innerWidth < 992){

      var $block_list = $('.scroll_banner'),
        $block_item = $block_list.find('h1'),
        block_list_width = $block_list.outerWidth(),
        block_item_width = $block_item.outerWidth(),
        total_width = block_item_width * $block_item.length,
        travel_distance = total_width - block_list_width + 80;

      var scene = new ScrollMagic.Scene({
        triggerElement: "#shopify-section-wc_announcement_bar",
        duration: '300%',
        triggerHook: 0
      })
        .setPin('.scroll_banner')
        //.setTween(tween)
        .addTo(controller);
      }else{

      var $block_list = $('.scroll_banner'),
        $block_item = $block_list.find('h1'),
        block_list_width = $block_list.outerWidth(),
        block_item_width = $block_item.outerWidth(),
        total_width = block_item_width * $block_item.length,
        travel_distance = total_width - block_list_width + 120;

      var scene = new ScrollMagic.Scene({
        triggerElement: "shopify-section-wc_announcement_bar",
        duration: '400%',
        triggerHook: 0
      })
        .setPin('.scroll_banner')
        //.setTween(tween)
        .addTo(controller);
    }


      scene.on('progress', function(e) {
      var progress = e.progress,
        move = -travel_distance * progress + "px";
      $block_item.css({
        transform: "translateX(" + move + ")"
      });
    });
  });

  // ================================================================================================


  // $(window).scroll(function(){
  //   AOS.init({
  //     offset: 50,
  //     duration: 600,
  //     easing: 'ease-in-sine',
  //     delay: 30,
  //   });  
  // });
  // console.log("section--",section,"top_scroll---",top_scroll)

  //  $(window).scroll(function(){
  //   var section =$(".offset_class").offset().top;
  //   var top_scroll = window.scrollY;
  //   if(top_scroll > section){

  //     console.log("123")

  //       AOS.init({
  //       offset: 50,
  //       duration: 600,
  //       easing: 'ease-in-sine',
  //       delay: 30,
  //     });  
  //   }
  // });


  // // Section changes colour and toggles nav on scroll up
  // let lastScrollTop = 0;
  // let HeaderScrollTop =  $(".offset_class").offset().top;
  // // console.log(HeaderScrollTop)
  // window.addEventListener('scroll', function (e) {
  //     let st = $(window).scrollTop();
  //   console.log(st)
  //     if (st > lastScrollTop) {
  //         // Scrolling Down 
  //       if(st > HeaderScrollTop){
  //           AOS.init({
  //           offset: 50,
  //           duration: 600,
  //           easing: 'ease-in-sine',
  //           delay: 30,
  //         }); 
  //       }
  //     } else {
  //         // Scrolling Up
  //     }
  //     lastScrollTop = st;
  // });



  //   AOS.init({
  //   offset: 50,
  //   duration: 600,
  //   easing: 'ease-in-sine',
  //   delay: 30,
  // });  

  // =============================================================================


  jQuery(function($) {

    // Function which adds the 'animated' class to any '.animatable' in view
    var doAnimations = function() {

      // Calc current offset and get all animatables
      var offset = $(window).scrollTop() + $(window).height(),
        $animatables = $('.animatable');

      // Unbind scroll handler if we have no animatables
      if ($animatables.length == 0) {
        $(window).off('scroll', doAnimations);
      }

      // Check all animatables and animate them if necessary
  		$animatables.each(function(i) {
        var $animatable = $(this);
        if (($animatable.offset().top + $animatable.height() - 150) < offset) {
          $animatable.removeClass('animatable').addClass('animated');
        }
      });

    };

    // Hook doAnimations on scroll, and trigger a scroll
    $(window).on('scroll', doAnimations);
    $(window).trigger('scroll');

  });

  // =============================================================================

  // $(window).scroll(function(){
  //   if ($(window).scrollTop() >= 28) {
  //       $('.about-us header').addClass('fixed_header');
  //   }
  //   else {
  //       $('.about-us header').removeClass('fixed_header');
  //   }
  // });



  var h3height = 0;
    $('.top_text').each(function() {
      if(h3height < $(this).outerHeight()){
      h3height = $(this).outerHeight();
    };
  });
  $('.top_text').height(h3height);

  var h3height = 0;
    $('.singal_boutiques h3').each(function() {
      if(h3height < $(this).outerHeight()){
      h3height = $(this).outerHeight();
    };
  });
  $('.singal_boutiques h3').height(h3height);

  var h3height = 0;
    $('.singal_vibe h3').each(function() {
      if(h3height < $(this).outerHeight()){
      h3height = $(this).outerHeight();
    };
  });
  $('.singal_vibe h3').height(h3height);

  var h3height = 0;
    $('.singal_vibe span').each(function() {
      if(h3height < $(this).outerHeight()){
      h3height = $(this).outerHeight();
    };
  });
  $('.singal_vibe span').height(h3height);

  // $('.cart .quantity__button').click(function(){
  //   window.location.reload();
  // });


  // ===============================================================================================================================
  // var $Child = 1; 
  // $('.slider-button.next').click(function(){
  //   $Child++;
  //   $('.product__media-list li:nth-child('+ $Child +')').removeClass('is-active').next().addClass('is-active')
  // })
  // $('.slider-button.next').click(function(){
  //   $Child++;
  //   if($('.product__media-list li:nth-child('+ $Child +')').hasClass("last")){
  //     $('.slider-button.next').addClass('none');
  //   }else{
  //     $('.product__media-list li:nth-child('+ $Child +')').removeClass('is-active').next().addClass('is-active')
  //   }
  // })

  // ===============================================================================================================================
  var $Child = 1;
  $('.slider-button.next').click(function(){
    $Child++;
    if($('.product__media-list li:nth-child('+ $Child +')').hasClass("last")){
      $('.slider-button.next').addClass('none');
    }else{
      $('.product__media-list li:nth-child('+ $Child +')').removeClass('is-active').next().addClass('is-active')
    }
  })


  var $New = 1;
  $('.slider-button.prev').click(function(){
    $New--;
    if($('.product__media-list li:nth-child('+ $New +')').hasClass("first")){
      $('.slider-button.prev').addClass('none');
    }else{
      $('.product__media-list li:nth-child('+ $New +')').removeClass('is-active').prev().addClass('is-active')
    }
  })

  $('#hang_color').on('change', function() {
    $("#tag-text-contaner").removeClass();
    $("#tag-text-contaner").addClass(this.value);
  });
});

function countChars(obj, errorID, textID){
  var maxLength = obj.maxLength;
  var strLength = obj.value.length;
  var charRemain = (maxLength - strLength);

    if(charRemain < 0){
        document.getElementById(errorID).innerHTML = 'You have exceeded the limit of '+maxLength+' characters';
    }else{
        document.getElementById(errorID).innerHTML = charRemain+' characters remaining';
  }

  document.getElementById(textID).innerHTML = obj.value;
}

function vg_check_() {
  const text = textInput.value;

  if (emojiRegex.test(text)) {
    warning.textContent = "Character is not allowed.";

    // Disable the main checkout button
    if (checkoutButton) {
      checkoutButton.disabled = true;
      checkoutButton.style.opacity = 0.5;
    }

    // Disable express checkout buttons
    expressButtons.forEach(buttons => {
      buttons.style.display = 'none';
    });
  } else {
    warning.textContent = "";

    if (checkoutButton) {
      checkoutButton.disabled = false;
      checkoutButton.style.opacity = 1;
    }

    expressButtons.forEach(buttons => {
      buttons.style.display = 'block';
    });
  }
}

/**
 * Check for emojis in Gift textarea and show message and disable checkout btn
 */
function vg_gift_textarea() {
  const textInput = document.getElementById("gift-input");
  if (!textInput) {
    return;
  }
  const warning = document.getElementById("warning");
  const checkoutButton = document.querySelector("button[name='checkout']");  // Main checkout button
  const expressButtons = document.querySelectorAll(".additional-checkout-buttons");  // Express checkout buttons

  // Regex to detect emojis
  const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/u;

  function checkForEmojis() {
    const text = textInput.value;

    if (emojiRegex.test(text)) {
      warning.textContent = "Character is not allowed.";

      // Disable checkout buttond
      if (checkoutButton) {
        checkoutButton.disabled = true;
        checkoutButton.style.opacity = 0.5;
      }

      expressButtons.forEach(button => {
        button.style.display = 'none';
      });
    } else {
      warning.textContent = "";
      // Enable checkout buttons
      if (checkoutButton) {
        checkoutButton.disabled = false;
        checkoutButton.style.opacity = 1;
      }

      expressButtons.forEach(button => {
        button.style.display = 'block';
      });
    }
  }

  // Perform an initial check on page load
  checkForEmojis();

  // Add event listener to re-check on each input change
  textInput.addEventListener("input", checkForEmojis);

  //Save the note to the cart as it changes. Checkout buttons injected by apps
  //SavedBy Checkout+, express checkout) go to /checkout without submitting
  //the #cart form, so the note would otherwise never reach the cart.
  let savedNote = textInput.value;
  
  function saveNote() {
    const note = textInput.value;

    if(note === savedNote || emojiRegex.test(note)) {
      return;
    }

    savedNote = note;

    fetch(window.routes.cart_update_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ note: note }),
      keepalive: true
    });
  }

  textInput.addEventListener("input", debounce(saveNote, 300));
  textInput.addEventListener("change", saveNote);
}

//custome.js loads async, so DOMContentLoaded may have already fired
if(document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", vg_gift_textarea);
}
else {
  vg_gift_textarea();
}
